module.exports = __webpack_public_path__ + "img/bonus_symbol_2.7eaa9936.png";